<app-toolbar page="link"></app-toolbar>

<div class="form-list link">

  <video controls #videoPlayer>
    <source [src]="url" type="video/mp4" />
    Browser not supported
</video>
</div>
